
import React from 'react';
import PopularCourses from '../AdmissionsDay/PopularCourses';
import Whystudycontry from '../AdmissionsDay/WhyStudyinCountry';
import StudiesFAQ from '../AdmissionsDay/StudiesFAQ';
import { useEffect } from 'react';
import { MetaTagsComp } from '../MetaTagsComp';
import EduFairStudentTestimonials from '../OverseasEdutionFair/eduFairStudTestimonials';
import EduFairKcByNumber from '../OverseasEdutionFair/eduFairKcByNumber';
import WhyChoosKcStudyAbroad from '../OverseasEdutionFair/eduFairWhyChoosekc';
import EduFairFooterCommon from '../OverseasEdutionFair/eduFairFooter';
import Benefitsofattentadmissionday from '../AdmissionsDay/BenefitsOfAdmissionsDay';
import AccomplishSection from '../OverseasEdutionFair/AccomplishSection';
import Appliactionweekheader from './Applicationweekheadr';
import FuturereadySection from './Futureredaysection';
import Toprankeduniversity from './Toprankeduniversities';

const LandingPageComponent: React.FC = (props: any) => {
    const eventData = props.pageData[0]

    useEffect(() => {
        const customStyle = document.documentElement.style
        customStyle.setProperty('--event-bgcolor', eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, [])

    return (
        <>
            {props.pageData?.length > 0 && <MetaTagsComp {...props.pageData[0].meta} />}

            {eventData?.bannerSection && <div>
                <Appliactionweekheader data={eventData?.bannerSection} jotformId={eventData?.meta?.jotforms[0]?.jotformid}  externalLink={eventData?.externalLink} />
            </div>}

            {eventData?.benefitsSection && <div>
                <Benefitsofattentadmissionday benefitdata={eventData?.benefitsSection} />
            </div>}

            {eventData?.topRankedSection && <div>
                <Toprankeduniversity toprankdata={eventData?.topRankedSection} />
            </div>}


            {eventData?.popularCourses && <div>
                <PopularCourses coursedata={eventData?.popularCourses} />
            </div>}
            <FuturereadySection eventData={eventData} />
            {eventData?.whyStudySection && <div>
                <Whystudycontry whystudydata={eventData?.whyStudySection}
                    jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>}

            {eventData?.whyChooseKc && <div>
                <WhyChoosKcStudyAbroad data={eventData?.whyChooseKc} />
            </div>}
            <AccomplishSection eventData={eventData}/>
            {eventData?.studentsSaySection && <div style={{ background: eventData?.studentsSaySection?.sectionBgColor || "#EEF2FB" }}>
                <EduFairStudentTestimonials data={eventData?.studentsSaySection} />
            </div>}

            {eventData?.kcNumbersSection && <div>
                <EduFairKcByNumber data={eventData?.kcNumbersSection} />
            </div>}

            {eventData?.faqSection && <div>
                <StudiesFAQ faqdata={eventData?.faqSection} />
            </div>}

            {eventData?.footer && <div>
                <EduFairFooterCommon data={eventData?.footer} jotformId={eventData?.meta?.jotforms[0]?.jotformid} externalLink={eventData?.externalLink}/>
            </div>}
        </>
    )
}

export default LandingPageComponent;